import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const adminApi = axios.create({ baseURL: API });

const ADMIN_TOKEN_KEY = "operamind_admin_token";
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
